/* React intl date formats */

export default {
    date: {
        numeric: {
            day:   'numeric',
            month: 'numeric',
            year:  'numeric'
        },
        short: {
            day:   'numeric',
            month: 'long',
            year:  'numeric'
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/formats.js